{
	"card": {
		"title": "ID document",
		"fastest": "Fastest",
		"scanPassport": "Scan the passport",
		"scanMyKad": "Scan the MyKad",
		"bodyPassport": "We read the two lines at the bottom of the photo page and fill in the details.",
		"bodyMyKad": "Scan the front and back in one go. We read the details from the front.",
		"scanNow": "Scan now",
		"upload": "Upload",
		"stepTwo": "Step 2 of 2",
		"scanBackTitle": "Add the back of the MyKad",
		"scanBackBody": "The back is required for a MyKad. Nothing is read from it."
	},
	"done": {
		"passportScanned": "Passport scanned",
		"myKadScanned": "MyKad scanned",
		"passportAdded": "Passport photo added",
		"myKadAdded": "MyKad photo added",
		"pdfAdded": "PDF added",
		"filled_one": "{{count}} detail filled. Check it below.",
		"filled_other": "{{count}} details filled. Check them below.",
		"sampleFilled_one": "{{count}} sample detail filled (demo). Replace it below.",
		"sampleFilled_other": "{{count}} sample details filled (demo). Replace them below.",
		"typeBelow": "Type the details below.",
		"rescan": "Rescan",
		"backAdded": "MyKad back added",
		"backOfCard": "Back of the card",
		"retake": "Retake"
	},
	"slots": {
		"front": "Front",
		"back": "Back",
		"passportPage": "Photo page",
		"pending": "Uploads when the record is created",
		"unsent": "Not uploaded",
		"missing": "Missing",
		"uploading": "Uploading… {{percent}}%",
		"processing": "Checking the file…",
		"pdf": "PDF",
		"size": "{{width}} × {{height}} px",
		"open": "Open {{name}}",
		"retry": "Retry upload",
		"replace": "Replace",
		"remove": "Remove",
		"locked": "The ID copy can't be changed now."
	},
	"tag": {
		"scanned": "Scanned",
		"check": "Check"
	},
	"sheet": {
		"titlePassport": "Scan the passport",
		"titleMyKad": "Scan the MyKad",
		"titleBack": "Scan the back of the MyKad",
		"bothSides": "Both sides are required. Scan them in one go: front first, then back.",
		"takePhoto": "Take a photo",
		"takePhotoHint": "Use the camera. We guide you.",
		"takePhotoHintTwo": "Front, then back. The camera stays open.",
		"uploadTitle": "Upload a photo or PDF",
		"uploadHint": "JPG, PNG, WEBP or PDF, up to {{mb}} MB",
		"uploadBoth": "Upload both sides",
		"uploadBothHint": "Select both files at once, front first",
		"privacy": "Read on this device. The image is uploaded only with the record.",
		"tips": {
			"flat": "Lay the document flat, the whole page or card inside the frame",
			"light": "Use even light, without glare or shadows",
			"mrz": "Include the two lines of letters and < at the bottom of the photo page",
			"card": "Use the front of the card, with all the text visible",
			"back": "Use the back of the card, the whole card visible"
		}
	},
	"camera": {
		"close": "Close camera",
		"passportPage": "Passport photo page",
		"frontOf": "Front of MyKad",
		"backOf": "Back of MyKad",
		"frontOfStep": "Front of MyKad, 1 of 2",
		"backOfStep": "Back of MyKad, 2 of 2",
		"mrzBand": "The 2 lines at the bottom go here",
		"starting": "Starting the camera…",
		"shoot": "Take photo",
		"upload": "Upload",
		"autoOn": "Auto on",
		"autoOff": "Auto off",
		"uploadPhoto": "Upload a photo",
		"deniedTitle": "Camera access is off",
		"deniedBody": "Allow camera access in the browser settings, or upload a photo instead.",
		"noneTitle": "No camera found",
		"noneBody": "Upload a photo of the document instead.",
		"guide": {
			"PLACE_PASSPORT": "Fit the photo page in the frame",
			"PLACE_FRONT": "Fit the front of the MyKad in the frame",
			"PLACE_BACK": "Fit the back of the MyKad in the frame",
			"TAP_PASSPORT": "Fit the photo page in the frame, then tap the button",
			"TAP_FRONT": "Fit the front of the MyKad in the frame, then tap the button",
			"TAP_BACK": "Fit the back of the MyKad in the frame, then tap the button",
			"DARK": "Find better lighting",
			"GLARE": "Tilt a little to remove the glare",
			"BLUR": "Hold steady",
			"HOLD": "Hold still",
			"counting": "Hold still — taking photo",
			"captured": "Captured",
			"flip": "Front saved. Turn the card over."
		}
	},
	"reading": {
		"titlePassport": "Reading the passport",
		"titleMyKad": "Reading the MyKad",
		"preparing": "Preparing the scanner…",
		"firstLoad": "The first scan loads the reader (about 4 MB). Later scans start at once.",
		"readingMrz": "Reading the two lines…",
		"readingCard": "Reading the card…",
		"checking": "Checking every check digit.",
		"fromFront": "Reading the number, name and address."
	},
	"result": {
		"title": "Check the details",
		"readPassport": "Passport read",
		"readMyKad": "MyKad read",
		"partly": "Partly read",
		"demoPassport": "Sample details, not read from the passport",
		"demoMyKad": "Sample details, not read from the MyKad",
		"demoSub": "Demo scan",
		"fromFront": "From the front of the card",
		"allDigits": "All check digits match",
		"someDigits": "Some check digits did not match",
		"notFound": "Not found",
		"check": "Check",
		"none": "(none)",
		"bornAbroad": "Outside Malaysia",
		"rescan": "Rescan",
		"use": "Use details",
		"fields": {
			"passportNumber": "Passport number",
			"myKadNumber": "MyKad number",
			"surname": "Surname",
			"givenNames": "Given names",
			"name": "Name",
			"nationality": "Nationality",
			"dateOfBirth": "Date of birth",
			"sex": "Sex",
			"stateOfBirth": "Place of birth",
			"address": "Address",
			"expiry": "Date of expiry"
		},
		"sex": {
			"M": "Man",
			"F": "Woman"
		},
		"warn": {
			"nationality": "This passport is {{nationality}}, but the registration is with {{organization}}. Check the eligibility rules.",
			"expiry": "This passport expires before {{date}}. It must be renewed before the Games.",
			"unconfirmed": "Some characters could not be confirmed. Check the fields marked “Check”.",
			"lookAlike": "Some characters look alike (such as 6 and G, 0 and O) and the check digit cannot tell them apart. Check the fields marked “Check” against the document."
		},
		"malaysian": {
			"title": "This is a Malaysian passport",
			"body": "Malaysian citizens register with a MyKad, not a passport. Switch to MyKad and scan the front of the card.",
			"switch": "Use MyKad",
			"cancel": "Cancel"
		}
	},
	"errors": {
		"tryAgain": "Try again",
		"manual": "Use photo, type details",
		"cancel": "Cancel",
		"readFailed": {
			"titlePassport": "Could not read the passport",
			"titleMyKad": "Could not read the MyKad",
			"bodyPassport": "Type the details from the passport below. The photo stays attached as the ID copy.",
			"bodyMyKad": "Type the details from the MyKad below. The photos stay attached as the ID copy.",
			"type": "Type the details"
		},
		"NO_MRZ": {
			"title": "The two lines could not be read",
			"body": "Make sure the two lines at the bottom of the photo page are in the picture, sharp and without glare."
		},
		"NO_MYKAD": {
			"title": "The MyKad could not be read",
			"body": "Use the front of the card, flat, in good light, with all the text inside the frame."
		},
		"ENGINE_LOAD": {
			"title": "The scanner could not start",
			"body": "Check the connection and try again, or type the details by hand."
		},
		"NO_WASM": {
			"title": "Scanning is not supported here",
			"body": "This browser or its security settings (such as Lockdown Mode) block the scanner. Try another browser, or type the details by hand."
		},
		"TIMEOUT": {
			"title": "The reader took too long",
			"body": "Reading did not finish in time. Try again with a sharper photo, or type the details."
		},
		"TOO_BIG": {
			"title": "The file is too large",
			"body": "Choose a file of {{mb}} MB or less."
		},
		"BAD_TYPE": {
			"title": "This file type is not accepted",
			"body": "Use a JPG, PNG or WEBP image, or a PDF."
		},
		"BAD_IMAGE": {
			"title": "The image could not be opened",
			"body": "Try a JPG or PNG photo."
		},
		"NO_CAMERA": {
			"title": "The camera is not available",
			"body": "Upload a photo instead."
		},
		"CAMERA_DENIED": {
			"title": "Camera access is off",
			"body": "Allow camera access in the browser settings, or upload a photo instead."
		}
	},
	"toast": {
		"filledPassport_one": "{{count}} detail filled from the passport",
		"filledPassport_other": "{{count}} details filled from the passport",
		"filledMyKad_one": "{{count}} detail filled from the MyKad",
		"filledMyKad_other": "{{count}} details filled from the MyKad",
		"backAdded": "MyKad back added",
		"pdfSaved": "PDF kept as the ID copy. Type the details below.",
		"typeDetails": "Photo kept as the ID copy. Type the details below.",
		"uploaded": "ID copy uploaded",
		"uploadFailed": "ID copy not uploaded",
		"uploadFailedAfterCreate": "The record was created, but the ID copy did not upload. Retry it on the Personal step."
	},
	"lock": {
		"titleMyKad": "Scan or upload your MyKad first",
		"titlePassport": "Scan or upload your passport first",
		"body": "Your details unlock once we have a photo of your ID, and most fields fill in for you. No ID to hand? Type the details yourself.",
		"manual": "Manually input details"
	},
	"demo": {
		"banner": "Demo scan — these details are sample data, not read from the card. Replace every field with what is printed on the ID."
	}
}
